import PCPHeader from "./PCPHeader/PCPHeader";
import PCPContents from "./PCPContents/PCPContents";
import Navbar from "../Navbar/Navbar";
import Footer from "../Footer/Footer";
import "./PageCostumerProfile.scss";
import { useEffect, useRef } from "react";
import { useAppContext } from "../Components/AppProvider";
function PageCostumerProfile() {
  return (
    <>
      <div className="pcp-container">
        <Navbar />
        <PCPHeader />
        <PCPContents />
        <Footer />
      </div>
    </>
  );
}
export default PageCostumerProfile;
